
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/premsa/3cat-plataforma",
      function () {
        return require("private-next-pages/corporatiu/premsa/3cat-plataforma/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/premsa/3cat-plataforma"])
      });
    }
  